<template>
  <div class="md-card md-card-nav-tabs">
    <div class="md-card-content">
      <div class="md-tabs md-primary">
        <div class="md-tabs-navigation" ref="navigation">
          <button
            type="button"
            class="md-button md-primary md-icon-label"
            v-for="(tab, index) in tabs"
            :key="index"
            :class="{
              'md-active': tab.isActive,
              'md-icon-label': tab.icon && tab.label,
              'md-no-pointer': disabled,
            }"
            v-show="!tab.hidden"
            :disabled="tab.disabled"
            @click="onClick(tab)">
            <div class="md-ripple">
              <div class="md-button-content">
                <i v-if="tab.icon" class="md-icon md-icon-font md-tab-icon">{{ tab.icon }}</i>
                <span class="md-tab-label">{{ tab.label }}</span>
              </div>
            </div>
          </button>
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeTab: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabs: [],
    }
  },
  created() {
    this.tabs = this.$children
  },
  mounted() {
    if (this.activeTab) this.setActiveTab(this.activeTab)
    else this.tabs[0].isActive = true
  },
  watch: {
    activeTab(value) {
      if (value) this.setActiveTab(value)
    }
  },
  methods: {
    setActiveTab(name) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.id === name)
      })
    },
    onClick(tab) {
      if (!this.disabled) this.setActiveTab(tab.id)
    }
  }
}
</script>

<style lang="css">
  .tab {
    padding: 2rem 1rem 1rem 1rem;
  }
  .md-no-pointer {
    cursor: initial !important;
  }
</style>